import { createFileRoute } from "@tanstack/react-router";

import SireAnalysis from "~/pages/HarmonyGenetics/SireAnalysis";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute(
  "/_private/meq-live-genetics/sire-analysis",
)({
  staticData: ROUTE_STATIC.meqLiveGenetics,
  component: SireAnalysis,
});
